module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"meta":{"title":{"complement":"Nogrid","inner":"Efektyvūs saulės elektrinių sprendimai įmonėms","separator":"-"}},"title":"Efektyvūs saulės elektrinių sprendimai įmonėms","side":"Patyrusių profesionalų komanda kiekvienai įmonei parenka tinkamiausią individualų saulės elektrinių sprendimą ir užtikrina sėkminga projekto įgyvendinimą nuo projektavimo iki elektrinės priežiūros."}}')
  delete Component.options._Ctor
}
